<template>
    <div class="blog-header">
        <Breadcrumbs
            v-if="breadcrumbs.length"
            :breadcrumbs
            class="breadcrumbs"
        />

        <h1 class="title">
            {{ title }}
        </h1>

        <BlogMenu
            v-if="categories"
            :categories
        />
    </div>
</template>

<script lang="ts" setup>
import type { BlogMenuFragment } from '@/graphql/api'

import BlogMenu from '@/components/cms/component/blog/BlogMenu.vue'
import type { Breadcrumb } from '@/components/ui/Breadcrumbs.vue'
import Breadcrumbs from '@/components/ui/Breadcrumbs.vue'

defineProps<{
    title?: string
    breadcrumbs: Breadcrumb[]
    categories?: BlogMenuFragment[]
}>()
</script>

<style lang="scss" scoped>
.blog-header {
    width: 1140px;
    max-width: 100%;
    margin: 80px auto 40px;
    padding: 0 20px;

    @include min-width(1140) {
        padding: 0;
    }

    .breadcrumbs {
        display: none;

        @include min-width(768) {
            display: block;
        }
    }

    .title {
        font-family: $parcel-font-stack;
        font-size: 2.25rem;
        line-height: 1.125em;
        letter-spacing: 0.01em;
        margin: 0 0 30px;

        @include min-width(768) {
            font-size: 2.875rem;
        }
    }
}
</style>
